import { env } from 'core/constants/env.constants';
import { routeRoleMapping } from 'core/routes/routes';
import { matchPath } from 'react-router-dom';

const authority = env.VITE_AUTH_AUTHORITY;
const clientId = env.VITE_AUTH_CLIENTID;
const responseType = env.VITE_AUTH_RESPONSE_TYPE;
const scope = env.VITE_AUTH_SCOPE;
const postLogoutRedirectUri = env.VITE_AUTH_POST_LOGOUT_REDIRECT_URL;

export const oidcConfig = {
    authority,
    clientId,
    response_type: responseType,
    scope,
    postLogoutRedirectUri,
};

export const oidcCookie = `oidc.user:${authority}:${clientId}`;

export const getTokenFromStorage = () => {
    const sessionStorageToken = sessionStorage.getItem(oidcCookie);
    return sessionStorageToken ? JSON.parse(sessionStorageToken) : undefined;
};

export const routeIsAllowed = (userRole: string | null, module: string) => {
    const matchingRoute = Object.keys(routeRoleMapping).find((pattern) => matchPath(pattern, module));

    if (!matchingRoute) {
        return false;
    }

    const roles = routeRoleMapping[matchingRoute];

    return roles && userRole && roles.includes(userRole);
};
